import { render, staticRenderFns } from "./SetOrder.vue?vue&type=template&id=4bee3428&scoped=true"
import script from "./SetOrder.vue?vue&type=script&lang=js"
export * from "./SetOrder.vue?vue&type=script&lang=js"
import style0 from "./SetOrder.vue?vue&type=style&index=0&id=4bee3428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee3428",
  null
  
)

export default component.exports